import { useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { setScrollHidden } from "@/libs/utils";
import ShareListingModal from "@/components/listing/ShareListingModal";
import HeartBlackIcon from "@/components/Icon/HeartBlackIcon";
import ShareBlackIcon from "@/components/Icon/ShareBlackIcon";
import { useAuthValue } from "@/contexts/contextAuth";

type Props = {};
const ListingPageNotFound = ({}: Props) => {
  const router = useRouter();
  const asPath = router.asPath;

  const { setIsSignup } = useAuthValue();
  const [shareLisingModalIsOpened, setShareListingModalIsOpened] =
    useState<boolean>(false);

  return (
    <div className="w-full md:max-w-[1000px] mx-auto">
      <div className="pt-8 w-full bg-white hidden sm:flex justify-between items-center z-40">
        <button
          className="flex items-center hover:underline cursor-pointer px-4 md:px-0 py-4"
          onClick={() => router.push("/buy")}
        >
          <span>
            <Image
              width={14}
              height={14}
              src="/assets/listings/arrow.png"
              alt="back"
            />
          </span>
          <span className="text-base text-[#212529] font-medium leading-5">
            &nbsp;&nbsp;Back to search
          </span>
        </button>
        <div className="flex items-center space-x-4 px-4">
          <HeartBlackIcon
            className="cursor-pointer filter drop-shadow-md"
            onClick={() => {
              setIsSignup(true);
              setScrollHidden();
            }}
          />
          <ShareBlackIcon
            className="cursor-pointer filter drop-shadow-md"
            onClick={() => {
              setShareListingModalIsOpened(true);
              setScrollHidden();
            }}
          />
        </div>
      </div>
      <div className="w-full flex justify-center pt-6">
        <Image
          width={212}
          height={200}
          src="/assets/no-search-results.svg"
          className="w-[50%] sm:w-auto "
          alt="pageNotFound"
        />
      </div>
      <div className="text-center">
        <p className="text-2xl font-bold opacity-95 pt-4">Page Not Found</p>
        <p className="text-base font-medium opacity-95">
          This page does not exsit.
        </p>
      </div>
      <div className="w-full flex justify-center py-6">
        <button
          className="bg-white hover:opacity-80 text-sm text-[#00b3de] font-medium py-2 px-4 border border-[#00b3de] rounded"
          onClick={() => router.push("/buy")}
        >
          Browse all vehicles
        </button>
      </div>
      {shareLisingModalIsOpened && (
        <ShareListingModal
          shareLisingModalIsOpened={shareLisingModalIsOpened}
          setShareListingModalIsOpened={setShareListingModalIsOpened}
          url={`${asPath}`}
        />
      )}
    </div>
  );
};

export default ListingPageNotFound;
